// Textos da legenda do PDF do Dashboard: reaproveitam as explicações dos ícones
// de informação do Comercial e acrescentam as dos indicadores de atendimento.
const COMMERCIAL_KEYS = [
  'REVENUE',
  'WON_COUNT',
  'AVERAGE_TICKET',
  'CONVERSION_RATE',
  'AVERAGE_PURCHASE_TIME',
  'CREATED_COUNT',
  'OPEN_COUNT',
  'OPEN_VALUE',
  'LOST_COUNT',
  'LOST_VALUE',
];
const SERVICE_KEYS = [
  'CONVERSATIONS',
  'FIRST_RESPONSE_TIME',
  'RESOLUTION_TIME',
  'RESOLUTION_COUNT',
];
const ATENDIMENTO_KEYS = [...SERVICE_KEYS, 'MESSAGES', 'CSAT', 'SLA'];

const item = (t, key) => ({
  term: t(`DASHBOARD.EXPORT_PDF.LEGEND_ITEMS.${key}.TERM`),
  text: t(`DASHBOARD.EXPORT_PDF.LEGEND_ITEMS.${key}.TEXT`),
});

export const commercialLegend = t => [
  ...COMMERCIAL_KEYS.map(key => ({
    term: t(`DASHBOARD.COMERCIAL.CARDS.${key}`),
    text: t(`DASHBOARD.COMERCIAL.TOOLTIPS.${key}`),
  })),
  {
    term: t('DASHBOARD.COMERCIAL.SECTIONS.STALLED'),
    text: t('DASHBOARD.COMERCIAL.TOOLTIPS.STALLED'),
  },
];

export const serviceLegend = t => SERVICE_KEYS.map(key => item(t, key));

export const atendimentoLegend = t => ATENDIMENTO_KEYS.map(key => item(t, key));

export const pdfNotes = (t, keys) =>
  keys.map(key => t(`DASHBOARD.EXPORT_PDF.NOTES.${key}`));
